<template>
  <div class="pageContainer app-container">
    <el-row class="flexStart">
<!--      <el-button size="small" icon="el-icon-search" @click="onAdd" plain type="primary" style="margin-left: 10px;">-->
<!--        新增-->
<!--      </el-button>-->

    </el-row>

    <el-row type="flex" :gutter="16" style="margin-top: 20px">
      <el-col :span="24" class="tabContainer">
        <el-tabs v-model="activeName" type="border-card" style="height: 100%;">
          <el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
            <el-table :data="tableData" stripe size="mini" style="width: 100%;margin-bottom: 20px;" border>
              <el-table-column prop="index" width="55" label="序号">
                <template slot-scope="scope">
                  {{scope.$index+1}}
                </template>
              </el-table-column>
              <el-table-column prop="table_name" label="标题"></el-table-column>
              <el-table-column prop="table_code" label="编码"></el-table-column>

              <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" @click="showDialog(scope.row)" type="text" size="small">修改</el-button>
                  <el-popconfirm width="200" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info"
                                 iconColor="red" @confirm="onDel(scope.row)" placement="left" title="是否确定删除？">
<!--                    <a slot="reference" size="small"-->
<!--                       style="cursor: pointer;color: red;font-size: 12px;margin-left: 10px;">-->
<!--                      <i class="el-icon-delete" style="margin-left: 10px;"></i>-->
<!--                      删除</a>-->
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>

          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-dialog :title="modalTitle" width="600px" :visible.sync="visible" :close-on-click-modal="false">
      <div class="flexStart" style="margin-top: 20px;width: 100%;">
        <span style="width: 70px;text-align: center;">标题:</span>
        <div class="flex_1">
          <el-input v-model.trim="editForm.table_name" type="text" style="width: 90%"/>
        </div>
      </div>
      <div class="flexStart" style="margin-top: 20px;width: 100%;">
        <span style="width: 70px;text-align: center;">编码:</span>
        <div class="flex_1">
          <el-input v-model.trim="editForm.table_code" type="text" style="width: 90%"/>
        </div>
      </div>

      <div class="flexStart" style="margin-top: 20px;width: 100%;">
        <span style="width: 70px;text-align: center;">状态:</span>
        <div class="flex_1">
          <el-switch
              v-model="editForm.stop"
              :active-value="0"
              :inactive-value="1"
              :active-text="editForm.stop?'禁用':'启用'">
          </el-switch>
        </div>
      </div>

      <div slot="footer">
        <el-button size="mini" el-icon="el-icon-remove" type="primary" @click="saveForm">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import api from '@/api/api';

export default {
  name: 'Student',
  components: {},
  data() {
    return {
      visible: false,
      modalTitle: '修改',
      editForm: {
        stop: 0,
        table_code: "",
        table_name: "",
      },
      //table
      tabMapOptions: [{label: '新生报道填表类型', key: 'CN'},],
      activeName: 'CN',
      tableData: [],
      pmid:5,
    }
  },
  mounted() {
    if(sessionStorage.getItem('userinfo')){
      let userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
      console.log(userinfo.pmid)
      this.pmid = (userinfo&&userinfo.pmid)?userinfo.pmid:this.pmid
    }
    this.getList();
  },
  methods: {
    getList() {
      this.$http.post('/api/t_stu_check_in_table_type_list',{
        pmid:this.pmid,
        }).then(res => {
          console.log(res.data.data)
        this.tableData = res.data.data
      })
    },
    onAdd(){
      this.visible = true
      this.modalTitle = '新增'
      this.editForm = {
        stop: 0,
        table_code: "",
        table_name: "",
      }
    },
    onDel(row){
      this.$http.post('/api/t_stu_check_in_table_type_delete', {
        id:row.id
      }).then(res => {
        this.$message.success('删除成功！')
        this.getList()
      })
    },
    showDialog(row) {
      this.modalTitle = '修改'
      this.visible = true
      this.editForm = row
    },
    saveForm() {
      if (!this.editForm.table_name) {
        this.$message.warning('标题不能为空！')
        return
      } else {
        this.editForm.pmid = this.pmid
        this.$http.post('/api/t_stu_check_in_table_type_edit',this.editForm).then(res => {
          this.visible = false
          this.$message.success('修改成功！')
          this.getList()
        })
      }
    },
  }
}
</script>
<style scoped lang="less" type="text/less">

</style>
